import { access2off, access3off, access4off, access2on, access3on, access4on, accessBanner, IconAlarm } from '@assets/images/main/index';
import { BlueIconPhone, BlueIconRFID, BlueIconRemote, BlueIconWatch, BlueIconWidget } from '@assets/images/icon/blue';
import {
  AdvantageImgD,
  AdvantageImgM,
  AdvantageImgT,
  Falldown1D,
  Falldown1M,
  Falldown1T,
  Falldown2D,
  Falldown2M,
  Falldown2T,
  Falldown3D,
  Falldown3M,
  Falldown3T,
  installationImg1D,
  installationImg1M,
  installationImg1T,
  installationImg2D,
  installationImg2M,
  installationImg2T,
  installationImg3D,
  installationImg3M,
  installationImg3T,
  installationImg4D,
  installationImg4M,
  installationImg4T,
  installationImg5D,
  installationImg5M,
  installationImg5T,
  hardwareImg1D,
  hardwareImg1M,
  hardwareImg1T,
  hardwareImg2D,
  hardwareImg2M,
  hardwareImg2T,
  hardwareImg3D,
  hardwareImg3M,
  hardwareImg3T,
  hardwareImg4D,
  hardwareImg4M,
  hardwareImg4T,
  hardwareImg5D,
  hardwareImg5M,
  hardwareImg5T,
  accessBannerProduct,
  accessBannerBg,
} from '@assets/images/main/access/components/index';
import { IconAccessLiteOff, IconAccessLiteOn, IconOsOff, IconOsOn } from '@assets/images/main/icon';
import { Icon3d3d, Icon3dAlert, Icon3dCycle, Icon3dDetect, Icon3dMap2, Icon3dMeter } from '@assets/images/icon';
import { IconBlueShield } from '@assets/images/main/icon/blue';

export default {
  banner: {
    title: '入退室はスムーズに、<br/>記録は自動で。',
    desc: 'タグやモバイルを所持した人物が近づくとドアが自動で開き、<br/>入退室履歴はORBRO OSにリアルタイムで保存されます。',
    productImg: accessBannerProduct,
    bgImg: accessBannerBg,
    schemeTitle: 'あなたに合った入退室システムをお選びください。',
    schemeDesc: '選び方でお困りですか？',
    schemeDesc2: 'までご連絡いただければ、<br/>専門スタッフがサポートいたします。',
    phone: '1522-9928',
  },
  mainPage: {
    product: {
      title: '製品構成を確認する',
      desc: '革新的な入退室システムの製品構成を確認しましょう。',
      mobile: {
        title: 'モバイル入退室',
        desc: 'モバイルを使用した入退室システムの始まり',
      },
      auto: {
        title: '自動ドア入退室',
        desc: '自動ドアに特化した入退室システムの始まり<br/>全ての入退室口に対応可能',
      },
      face: {
        title: '顔認識入退室',
        desc: '顔認識、モバイル入退室、NFCカードなど<br/>あらゆる入退室方法に対応',
      },
      accessory: {
        title: '入退室アクセサリ',
        desc: '入退室システムに関連する<br/>全ての製品をご覧ください',
      },
    },
  },

  FAQ: [
    {
      title: 'Orbro Accessはどのように入退室を認証しますか？',
      description: '製品によりBLE（Bluetooth）、NFC、AI顔認証などの認証方式をサポートしており、基本的にはモバイルアプリによる位置ベースの認証です。',
    },
    {
      title: 'スマートフォンがなくても入退室できますか？',
      description: 'はい、可能です。専用タグ「Orbro Access Key」を使えば、スマートフォンがなくても認証できます。',
    },
    {
      title: '自動ドアがない場所でも使えますか？',
      description: 'はい、使えます。自動ドアがなくてもEMロックやデッドボルトと連携して、入退室の制御が可能です。',
    },
    {
      title: '入退室の記録はどう保存されますか？',
      description: '入退室の時刻、滞在時間、認証方式などはすべてORBRO OSに自動で保存され、管理画面で確認できます。',
    },
    {
      title: 'ネットワークがない場所でも使えますか？',
      description: 'はい、使えます。サーバーがない環境でもオフラインモードで動作しますが、その場合記録は保存されません。',
    },
    {
      title: '外部システムとの連携は可能ですか？',
      description: 'はい。Access LiteおよびAccess ProはAPI連携に対応しており、社内セキュリティや勤怠システムなどと簡単に統合できます。',
    },
    {
      title: '顔認証による入退室も可能ですか？',
      description: 'はい、Access ProモデルではAI顔認証による入退室が可能です。非接触で迅速な認証ができ、安全性と効率性に優れています。',
    },
  ],

  bannerData: [
    {
      icon: access2on,
      iconInv: access2off,
      image: '',
      iconText: 'Access Auto',
      titleKey: '自動ドアに特化した入退室システムの始まり<br/>すべてのドアに対応可能',
      descKey: 'access.banner.desc',
      sub: 'New',
      link: '/jp/access/auto',
    },
    {
      icon: IconAccessLiteOn,
      iconInv: IconAccessLiteOff,
      image: '',
      iconText: 'Access Lite',
      titleKey: '顔認証、モバイル入退室、NFCカードなど<br/>あらゆる出入口方式に対応',
      descKey: 'access.banner.desc',
      sub: 'New',
      link: '/jp/access/lite',
    },
    {
      icon: access3on,
      iconInv: access3off,
      image: '',
      iconText: 'Access Pro',
      titleKey: '顔認証、モバイル入退室、NFCカードなど<br/>あらゆる出入口方式に対応',
      descKey: 'access.banner.desc',
      sub: 'New',
      link: '/jp/access/pro',
    },
    {
      icon: access4on,
      iconInv: access4off,
      image: '',
      iconText: 'Accessories',
      titleKey: '入退室システムに関する<br/>すべての製品をチェック',
      descKey: 'access.banner.desc',
      sub: 'New',
      link: '/jp/access/accessory',
    },
    // 他のグループがあれば追加
  ],

  falldown: {
    left: {
      title: 'スマートフォンでエントリーメソッドを統合、<br/>最もモダンなアクセスシステム',
      desc: '通常のドアから自動ドア、スピードゲートまで、スマートフォンを使用して現代社会のさまざまな入場口に簡単にアクセスできます。私たちの日常生活に最も近いシステムを使用して、最も効率的なデジタル変革を体験してください。',

      fall: [
        {
          title: 'スマートフォンエントリー',
          desc: 'すべてのiOS/Androidスマートフォンを介してアクセスできます。',
          img: {
            desktop: Falldown1D,
            tablet: Falldown1T,
            mobile: Falldown1M,
          },
        },
        {
          title: 'スマートウォッチエントリー',
          desc: 'スマートウォッチを使用してより便利なアクセスが可能です。',
          img: {
            desktop: Falldown2D,
            tablet: Falldown2T,
            mobile: Falldown2M,
          },
        },
        {
          title: 'RFIDカードエントリー',
          desc: '既存の従業員IDカードを使用してアクセスできます。',
          img: {
            desktop: Falldown3D,
            tablet: Falldown3T,
            mobile: Falldown3M,
          },
        },
      ],
    },

    rightImg: '',
  },

  functions: {
    title: 'コアはハードウェア、<br/>すべてがスムーズに革新します。',
    desc: '',
    line: 2,
    card: [
      {
        img: {
          desktop: hardwareImg1D,
          tablet: hardwareImg1T,
          mobile: hardwareImg1M,
        },
        tag: 'ステータスLED',
        title: 'デュアルチャンネルNFC/Bluetooth<br/>アクセス',
        desc: 'NFCカードなどを使用したアクセスはもちろん、モバイルからスマートウォッチのエントリーまで可能です。',
        size: '3',
      },
      {
        img: {
          desktop: hardwareImg2D,
          tablet: hardwareImg2T,
          mobile: hardwareImg2M,
        },
        tag: '電源供給',
        title: 'PoE使用により、<br/>通信と電力が統合',
        size: '1',
      },
      {
        img: {
          desktop: hardwareImg3D,
          tablet: hardwareImg3T,
          mobile: hardwareImg3M,
        },
        tag: '簡単な取り付け',
        title: '専用ブラケットで<br/>簡単な取り付け',
        size: '2',
      },
      {
        img: {
          desktop: hardwareImg4D,
          tablet: hardwareImg4T,
          mobile: hardwareImg4M,
        },
        tag: 'スピーカー',
        title: 'スピーカーを介した<br/>エントリー通知',
        size: '2',
      },
      {
        color: '#000',
        img: {
          desktop: hardwareImg5D,
          tablet: hardwareImg5T,
          mobile: hardwareImg5M,
        },
        tag: 'ステータスLED',
        darkTitle: '暗い夜にも<br/>',
        lightTitle: 'ステータス確認 ',
        darkTitle2: '可能',
        desc: 'RGB LEDを使用してデバイスのステータス、エントリー確認などを確認できます。',
        size: '2',
      },
    ],
  },

  installation: {
    title: '製品の取り付けについて心配しないでください。<br/>私たちがカバーします。',
    card: [
      {
        img: {
          desktop: installationImg1D,
          tablet: installationImg1T,
          mobile: installationImg1M,
        },
        tag: 'オンプレミスサーバー提供',
        title: 'エンタープライズグレード<br/>サーバー提供',
      },
      {
        img: {
          desktop: installationImg2D,
          tablet: installationImg2T,
          mobile: installationImg2M,
        },
        tag: 'プロフェッショナルオンサイトインストールサポート',
        title: '最速の取り付け日をご案内いたします。<br/>1522-9928までお問い合わせください。',
        desc: '平日、午前9時～午後6時',
      },
      {
        img: {
          desktop: installationImg3D,
          tablet: installationImg3T,
          mobile: installationImg3M,
        },
        tag: 'エントリーアクセサリー',
        title: 'デッドボルトの取り付け可能',
      },
      {
        img: {
          desktop: installationImg4D,
          tablet: installationImg4T,
          mobile: installationImg4M,
        },
        tag: 'エントリーアクセサリー',
        title: 'EMロックの取り付け可能',
      },
      {
        theme: 'black',
        img: {
          desktop: installationImg5D,
          tablet: installationImg5T,
          mobile: installationImg5M,
        },
        tag: 'エントリーアクセサリー',
        title: '電動ストライクの取り付け可能',
      },
    ],
  },

  advantage: {
    img: {
      desktop: AdvantageImgD,
      tablet: AdvantageImgT,
      mobile: AdvantageImgM,
    },
    title: 'オブロが従来のアクセスシステムと異なる点',
    desc: 'ORBROは、現代社会のアクセス方法の変化に適応し、従来のアクセス方法から最新のスマートテクノロジーまで、さまざまなエントリーメソッドを提供する最もモダンなアクセスターミナルです。ユーザーに便利で安全なアクセス環境を提供します。',
    card: [
      {
        icon: BlueIconPhone,
        title: 'スマートフォンを使用したエントリー',
        desc: 'iOS / Androidアプリを使用して入場ポイントを制御できます。',
      },
      {
        icon: BlueIconWidget,
        title: 'ウィジェット提供',
        desc: 'ウィジェットはモバイルアプリをより便利に使用する方法です。',
      },
      {
        icon: BlueIconWatch,
        title: 'スマートウォッチを使用したエントリー',
        desc: 'スマートウォッチを使用して便利なエントリーメソッドを体験してください。',
      },
      {
        icon: BlueIconRemote,
        title: 'リモート制御',
        desc: '管理者はリモートから入場ポイントを管理できます。',
      },
      {
        icon: BlueIconRFID,
        title: 'RFID＆NFCカード',
        desc: 'RFIDまたはNFCタグをタッグして入場ポイントを簡単に制御できます。',
      },
    ],
  },
  func: {
    title: '機能をもっと見る',

    data: [
      {
        img: IconBlueShield,
        title: '認証方式',
        desc: 'BLE（Bluetooth）、NFC、AI顔認証など、さまざまな認証方式を提供しています。製品によって機能は異なり、使用環境に合わせて選択できます。',
      },
      {
        img: IconAlarm,
        title: 'モバイルによる自動入退室',
        desc: '専用アプリをインストールしたユーザーがスマートフォンを持ってドアに近づくと、<br/>操作なしで自動認証されドアが開きます。',
      },
      {
        img: Icon3dMeter,
        title: 'タグによる非接触入退室',
        desc: 'Access Keyタグを使用することで、スマートフォンがなくても認証が可能です。<br/>タグを所持するだけで自動的にドアが制御されます。',
      },
      {
        img: Icon3dCycle,
        title: 'アクセス権限管理',
        desc: 'ユーザー別、エリア別にアクセス権限を設定し、セキュリティレベルに応じて制限をかけることができます。',
      },
      {
        img: Icon3dMap2,
        title: 'アクセス履歴の自動保存',
        desc: '入退室時刻、滞在時間、認証方式などの情報をORBRO OSにリアルタイムで保存します。<br/>管理画面で日付別・ユーザー別に確認可能です。',
      },
      {
        img: Icon3dAlert,
        title: 'オフライン環境対応',
        desc: 'オフラインモードを活用することで、インターネット環境がない場所でも独立して入退室認証が可能です。',
      },
      {
        img: Icon3dDetect,
        title: '自動ドア連携／単独対応',
        desc: '自動ドアがない場合でも、EMロックやデッドボルトと連携して、認証後にドアのロックを自動解除できます。',
      },
      {
        img: Icon3d3d,
        title: 'APIによる外部システム連携',
        desc: 'Access Lite、Access ProモデルはAPI連携をサポートしており、他のセキュリティシステムや勤怠、予約システムなどと統合できます。',
      },
    ],
  },
};
